import { combineReducers } from "redux";

import accountsReducer from "./accountsReducer";
import addressReducer from "./addressReducer";
import adminDashboardReducer from "./adminDashboardReducer";
import administratorReducer from "./administratorReducer";
import adsReducer from "./adsReducer";
import attributeReducer from "./attributeReducer";
import authReducer from "./authReducer";
import billReducer from "./billReducer";
import blogReducer from "./blogReducer";
import brandReducer from "./brandReducer";
import businessTypeReducer from "./businessTypeReducer";
import campaignReducer from "./campaignReducer";
import careerReducer from "./careerReducer";
import categoryReducer from "./categoryReducer";
import commissionReducer from "./commissionReducer";
import contentReducer from "./contentReducer";
import currencyReducer from "./currencyReducer";
import customerReducer from "./customerReducer";
import deliverOrderListReducer from "./deliverOrderListReducer";
import designation from "./designation";
import discountReducer from "./discountReducer";
import discountSummaryReducer from "./discountSummaryReducer";
import discountTypeReducer from "./discountTypeReducer";
import festivalReducer from "./festivalReducer";
import inventoryReducer from "./inventoryReducer";
import invoiceReducer from "./invoiceReducer";
import measurementChartReducer from "./measurementChartReducer";
import orderReducer from "./orderReducer";
import { orderRequisitionReducer } from "./orderRequisitionReducer";
import outletReducer from "./outletReducer";
import parcelDeliveryReducer from "./parcelDeliveryReducer";
import paymentMethodReducer from "./paymentMethodReducer";
import pendingOrderListReducer from "./pendingOrderListReducer";
import popUpReducer from "./popUpReducer";
import processingOrderListReducer from "./processingOrderListReducer";
import productCampaignSellerReducer from "./productCampaignSellerReducer";
import productImageByColorReducer from "./productImageByColorReducer";
import productImageReducer from "./productImageReducer";
import productReducer from "./productReducer";
import productSliderReducer from "./productSliderReducer";
import productVariantOptionReducer from "./productVariantOptionReducer";
import productVariantOptionValueReducer from "./productVariantOptionValueReducer";
import productVariantReducer from "./productVariantReducer";
import profileReducer from "./profileReducer";
import promotionDetailsReducer from "./promotionDetailsReducer";
import promotionReducer from "./promotionReducer";
import purchaseOrderReducer from "./purchaseOrderReducer";
import { realtimeDataReducer } from "./realtimeDataReducer";
import { refundReducer } from "./refundReducer";
import reportReducer from "./reportReducer";
import searchSuggestionReducer from "./searchSuggestionReducer";
import secondaryImageReducer from "./secondaryImageReducer";
import sellerProfileReducer from "./sellerProfileReducer";
import sellerReducer from "./sellerReducer";
import shippingReducer from "./shippingReducer";
import shopReducer from "./shopReducer";
import { sizeChartReducers } from "./sizeChartReducers";
import storeReducer from "./storeReducer";
import transactionReducer from "./transactionReducer";
import unitReducer from "./unitReducer";
import vendorReducer from "./vendorReducer";
import voucherReducer from "./voucherReducer";
import warrantyReducer from "./warrantyReducer";
import auditReducer from "./auditReducer";

export default combineReducers({
  adsReducer: adsReducer,
  addressReducer: addressReducer,
  attributeReducer: attributeReducer,
  authReducer: authReducer,
  auditReducer: auditReducer,
  blogReducer: blogReducer,
  brandReducer: brandReducer,
  businessTypeReducer: businessTypeReducer,
  categoryReducer: categoryReducer,
  contentReducer: contentReducer,
  currencyReducer: currencyReducer,
  customerReducer: customerReducer,
  campaignReducer: campaignReducer,
  deliverOrderListReducer: deliverOrderListReducer,
  designation: designation,
  discountReducer: discountReducer,
  discountSummaryReducer: discountSummaryReducer,
  discountTypeReducer: discountTypeReducer,
  festivalReducer: festivalReducer,
  inventoryReducer: inventoryReducer,
  invoiceReducer: invoiceReducer,
  measurementChartReducer: measurementChartReducer,
  orderReducer: orderReducer,
  outletReducer: outletReducer,
  paymentMethodReducer: paymentMethodReducer,
  pendingOrderListReducer: pendingOrderListReducer,
  popUpReducer: popUpReducer,
  productCampaignSellerReducer: productCampaignSellerReducer,
  processingOrderListReducer: processingOrderListReducer,
  productImageByColorReducer: productImageByColorReducer,
  productImageReducer: productImageReducer,
  productReducer: productReducer,
  productSliderReducer: productSliderReducer,
  productVariantOptionReducer: productVariantOptionReducer,
  productVariantOptionValueReducer: productVariantOptionValueReducer,
  productVariantReducer: productVariantReducer,
  profileReducer: profileReducer,
  promotionDetailsReducer: promotionDetailsReducer,
  promotionReducer: promotionReducer,
  realtimeDataReducer: realtimeDataReducer,
  reportReducer: reportReducer,
  accountsReducer: accountsReducer,
  adminDashboardReducer: adminDashboardReducer,
  secondaryImageReducer: secondaryImageReducer,
  sellerProfileReducer: sellerProfileReducer,
  sellerReducer: sellerReducer,
  shippingReducer: shippingReducer,
  storeReducer: storeReducer,
  shopReducer: shopReducer,
  transactionReducer: transactionReducer,
  warrantyReducer: warrantyReducer,
  commissionReducer: commissionReducer,
  unitReducer: unitReducer,
  vendorReducer: vendorReducer,
  voucherReducer: voucherReducer,
  voucherValidity: voucherReducer,
  refundReducer: refundReducer,
  orderRequisition: orderRequisitionReducer,
  careerReducer: careerReducer,
  sizeChartReducers: sizeChartReducers,
  purchaseOrderReducer: purchaseOrderReducer,
  parcelDeliveryReducer: parcelDeliveryReducer,
  searchSuggestionReducer: searchSuggestionReducer,
  administratorReducer: administratorReducer,
  billReducer: billReducer,
});
